import React, { useEffect } from 'react';
import SearchBar from 'src/modules/search/shared/components/searchBar';
import i18n from 'src/utils/translate';
import { trackFootfallEvent } from 'src/utils/footfall';
import * as log from 'loglevel';
import EventType from 'src/constants/footfallEventTypes';

const ErrorPage = ({ status = 404, error }: {status?: number, error?: string}) => {
  useEffect(() => {
    log.error(error || new Error(`${status} User is being shown an oops page`));
    trackFootfallEvent(EventType.SAW_OOPS_PAGE);
  }, []);

  const statuses: {[key: number]: string} = {
    404: i18n.t('Oops. Looks like that page can\'t be found!'),
    410: i18n.t('Oops. Looks like that page no longer exists!'),
    500: i18n.t('Oops. Looks like that page no longer exists!'),
  };

  return (
    <div className="error-page">
      <h1 className="error-page__title">{statuses[status] || statuses[404]}</h1>
      <h2 className="error-page__sub-title">{i18n.t('Try a search')}</h2>
      <SearchBar
        className="error-page__search"
        disableQueryPlaceholder={true}
        placeholderText="Search HealthUnlocked"
      />
    </div>
  );
};

export default ErrorPage;
